module.exports = __webpack_public_path__ + "img/eyemed-logo.7cecbe05.svg";